import { render } from "./MobileMenu.vue?vue&type=template&id=3e1c4971"
import script from "./MobileMenu.vue?vue&type=script&lang=js"
export * from "./MobileMenu.vue?vue&type=script&lang=js"
script.render = render

export default script